/**
 * New invoice chooser — invoices are always billed FROM an approved estimate or a job's actual
 * time & materials (the backend has no blank-invoice create), so "New invoice" routes the user
 * to pick a source instead of dead-ending. Reached from the Home "Create" section and the
 * Invoices list "+ New invoice" button.
 *
 * `new` is a static route so it takes precedence over invoices/[id] for /invoices/new.
 * NEVER imports @smartbox/* (mobile invariant 1). Design-system primitives only; no raw styles.
 */
import { Stack, useRouter } from 'expo-router';
import { Screen, Text, ListRow } from '../../../src/components/ui';

export default function NewInvoiceScreen() {
  const router = useRouter();
  return (
    <>
      <Stack.Screen options={{ title: 'New invoice' }} />
      <Screen scroll>
        <Text variant="title">Create an invoice</Text>
        <Text variant="body" color="secondary">
          Invoices are billed from an approved estimate or a job&apos;s time &amp; materials. Choose
          where this one comes from.
        </Text>
        <ListRow
          title="From an estimate"
          subtitle="Bill an approved estimate"
          onPress={() => router.replace('/(app)/estimates' as never)}
          accessibilityLabel="Create an invoice from an estimate"
        />
        <ListRow
          title="From a job"
          subtitle="Bill a job's time & materials"
          onPress={() => router.replace('/(app)/jobs' as never)}
          accessibilityLabel="Create an invoice from a job"
        />
      </Screen>
    </>
  );
}
